import { Table } from 'react-bootstrap';

interface DwellingFeatureTableProps {
  rows: DwellingFeatureTableRow[];
  visibleRows?: number;
}

export interface DwellingFeatureTableRow {
  title: string;
  state: string | JSX.Element;
}

const DwellingFeatureTable = (props: DwellingFeatureTableProps) => {
  return (
    <Table>
      <tbody>
        <tr className="border-bottom" />
        {props.rows.slice(0, props.visibleRows).map((row, i) => (
          <tr key={i}>
            <td className="text-start" style={{ color: '#444444', fontSize: '14px' }}>{row.title}</td>
            <td className="text-start" style={{ color: '#000D5B', fontSize: '14px' }}>{row.state}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default DwellingFeatureTable;
